import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import theme from '../../../assets/theme';

const ShowMoreButton = ({
  onClick,
  showMore,
  numberOfComments,
}: {
  onClick: (showMore: boolean) => void;
  showMore: boolean;
  numberOfComments?: number;
}) => {
  const { t } = useTranslation('Feed');
  const showMoreButtonText = () => {
    const numberOfCommentsBetween1and10 =
      numberOfComments && numberOfComments <= 10 && numberOfComments >= 1;
    if (numberOfComments && numberOfCommentsBetween1and10) {
      const comments = numberOfComments.toString();
      return showMore
        ? t('showless', { defaultValue: 'show less' })
        : t('showMore', {
            defaultValue: `show {{comments}} more`,
            comments,
          });
    } else {
      return showMore ? t('showless', { defaultValue: 'show less' }) : t('show more');
    }
  };
  return <Button onClick={() => onClick(!showMore)}>... {showMoreButtonText()}</Button>;
};

export default ShowMoreButton;

const Button = styled.button`
  outline: none;
  font-weight: bold;
  font-size: 14px;
  line-height: 140%;
  color: #a5a5a5;
  border: none;
  background: transparent;
  transition: all 0.1s;
  cursor: pointer;
  &:hover {
    color: ${theme.colors.black};
    text-decoration: underline;
  }
  &:active {
    color: ${theme.colors.black};
    text-decoration: underline;
  }
`;
